export const validateNumber = (_value) => {
    const validate = /^\d*$/.test(_value)
    if (validate)
        return _value
    //else isValid = /^-?\d*[,.]?\d*$/.test(value);

    return '';
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;